module.exports = __webpack_public_path__ + "img/selected3-min.0713be01.png";